import { Component } from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Control, Form } from 'forms/rrf';
import ArrowButton from '../../../common/button-arrow';
import BsRadio from '../../../common/form/elements/bs-radio';

class FeatureToggleForm extends Component {
  render() {
    const {
      model, description, onSubmit, formValid
    } = this.props;

    return (
      <div className="container-fluid">
        <Form model={model} onSubmit={onSubmit}>
          <FormGroup controlId="featureTogglEnabled">
            <div>
              <FormLabel>{description ? description.value : ''}</FormLabel>
            </div>
            <Control.radio
              model=".enabled"
              value="true"
              component={BsRadio}
            >
              Enable
            </Control.radio>
            <Control.radio
              model=".enabled"
              value="false"
              component={BsRadio}
            >
              Disable
            </Control.radio>
          </FormGroup>
          <Row>
            <Col md={{span: 2, offset: 10}}>
              <ArrowButton
                className="float-end"
                arrow={false}
                disabled={!formValid}
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  description: state.deep.forms.admin_feature_toggle_save.description,
  formValid: state.deep.forms.admin_feature_toggle_save.$form.valid
});

export default connect(mapStateToProps)(FeatureToggleForm);
